import { ArrowDownward, ArrowUpward } from '@mui/icons-material'
import { useEffect, useState } from 'react'
import { databaseLocation } from '../../dummyData'
import axios from 'axios'

export default function FeaturedInfo() {
	const [invoiceList, setInvoiceList] = useState([])
	const [totalRevenue, setTotalRevenue] = useState(0) // Zahl statt []
	const [monthlyRevenue, setMonthlyRevenue] = useState(0) // Zahl statt 0

	// 1) Invoices laden – ohne async direkt im Effect
	useEffect(() => {
		const ctrl = new AbortController()
		;(async () => {
			try {
				const { data } = await axios.get(`${databaseLocation}/api/invoice/getAll`, {
					signal: ctrl.signal,
				})
				setInvoiceList(data || [])
			} catch (e) {
				if (e.name !== 'CanceledError' && e.name !== 'AbortError') console.error(e)
			}
		})()
		return () => ctrl.abort() // echter Cleanup
	}, [])

	// 2) Positionen aller Invoices laden und Summen berechnen
	useEffect(() => {
		if (invoiceList.length === 0) return

		let cancelled = false
		;(async () => {
			try {
				// Alle Positionen parallel laden
				const responses = await Promise.all(
					invoiceList.map((inv) =>
						axios.get(`${databaseLocation}/api/invoicePositions/get/${inv.invoiceId}`)
					)
				)

				// Preise pro Invoice summieren
				const perInvoiceTotals = responses.map((r) =>
					(r.data || []).reduce((sum, pos) => sum + Number(pos.Price || 0), 0)
				)

				// Gesamtsumme
				const total = perInvoiceTotals.reduce((a, b) => a + b, 0)

				// 30-Tage-Summe
				const cutoff = new Date()
				cutoff.setDate(cutoff.getDate() - 30)
				const monthly = perInvoiceTotals.reduce((sum, invTotal, idx) => {
					const invDate = new Date(invoiceList[idx].date)
					return invDate >= cutoff ? sum + invTotal : sum
				}, 0)

				if (!cancelled) {
					setTotalRevenue(total)
					setMonthlyRevenue(monthly)
				}
			} catch (e) {
				console.error(e)
			}
		})()

		return () => {
			cancelled = true
		} // echter Cleanup
	}, [invoiceList, databaseLocation])

	return (
		<div className='flex gap-6'>
			<div className='w-full mx-4 p-8 rounded-lg cursor-pointer shadow-[5px_5px_15px_-7px_#000000]'>
				<span className='text-xl'>Revenue</span>
				<div className='my-2.5 flex items-center'>
					<span className='text-3xl font-semibold'>{monthlyRevenue.toFixed(2)} €</span>
				</div>
				<span className='text-sm text-gray-500'>Last 30 days</span>
			</div>
			<div className='w-full p-8 rounded-lg cursor-pointer shadow-[5px_5px_15px_-7px_#000000]'>
				<span className='text-xl'>Revenue</span>
				<div className='my-2.5 flex items-center'>
					<span className='text-3xl font-semibold'>{totalRevenue.toFixed(2)} €</span>
				</div>
				<span className='text-sm text-gray-500'>In Total</span>
			</div>
		</div>
	)
}
